import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/checkout/:id",
  paypalPaymentSuccess: "/checkout/paypal/payment-success/:subscriptionId",
};
